import { UserManager, WebStorageStateStore } from 'oidc-client';

const settings = {
  authority: 'https://cognito-idp.eu-central-1.amazonaws.com/eu-central-1_gZSBl4S94',
  client_id: '3f14rhgkirtiei23lhifn3fioj',
  client_secret: '405oh48rfaut240rgs9n9cco1f8ti48umb584bvp3oo6bmv09m',
  redirect_uri: 'https://admin.ktv-hockeycamp.de/callback',
  //redirect_uri: 'http://localhost:8080/admin/callback',
  response_type: 'code',
  scope: 'openid email',
  post_logout_redirect_uri: 'http://localhost:8080/',
  userStore: new WebStorageStateStore({ store: window.localStorage })
};

const userManager = new UserManager(settings);

export default userManager;
